module.exports = __webpack_public_path__ + "img/kayak3.1255e51e.jpg";